const currencyArray = ["TWD", "USD", "JPY", "KRW", "THB", "RMB"];
const getCurrencyFormatWithSymbol = (currencyCode: string) => {
  return {
    style: "currency",
    currency: currencyCode || "TWD",
    currencyDisplay: "symbol",
  };
};

const getCurrencyFormatWithCode = (currencyCode: string) => {
  return {
    style: "currency",
    currency: currencyCode || "TWD",
    currencyDisplay: "code",
  };
};

const getCurrencyFormatNumbersOnly = (currencyCode: string) => {
  const currencyPayload = currencyArray.includes(currencyCode)
    ? {
        style: "currency",
        currency: currencyCode || "TWD",
      }
    : {};
  return {
    ...currencyPayload,
    currencyDisplay: "none",
  };
};

const getCurrencyFormatCompact = () => {
  return {
    currencyDisplay: "none",
    notation: "compact",
    compactDisplay: "short",
  };
};

function formatCurrency(
  value: number,
  format: ReturnType<typeof getCurrencyFormatNumbersOnly>,
  lang: string
) {
  const stripSymbols = format.currencyDisplay === "none";
  const localFormat = stripSymbols
    ? { ...format, currencyDisplay: "code" }
    : format;
  let result = Intl.NumberFormat(lang, localFormat).format(value);
  if (stripSymbols) {
    result = result.replace(/[a-z]{3}/i, "").trim();
  }
  return result;
}

export const formatCurrencyNumberOnly = (value: number, currencyCode: string) =>
  formatCurrency(value, getCurrencyFormatNumbersOnly(currencyCode), "en-US");

export const formatCurrencyWithSymbol = (value: number, currencyCode: string) =>
  formatCurrency(value, getCurrencyFormatWithSymbol(currencyCode), "en-US");

export const formatCurrencyWithCode = (value: number, currencyCode: string) =>
  formatCurrency(value, getCurrencyFormatWithCode(currencyCode), "en-US");

export const formatCurrencyCompact = (value: number) =>
  formatCurrency(value, getCurrencyFormatCompact(), "en-US");
